/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo(value) {
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'UserPayload': json['UserPayload'] == null ? undefined : json['UserPayload'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'UserPayload': value['UserPayload'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo.js.map